import { render, staticRenderFns } from "./TruckStatusChart.vue?vue&type=template&id=5d48b7ac&scoped=true&"
import script from "./TruckStatusChart.vue?vue&type=script&lang=js&"
export * from "./TruckStatusChart.vue?vue&type=script&lang=js&"
import style0 from "./TruckStatusChart.vue?vue&type=style&index=0&id=5d48b7ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d48b7ac",
  null
  
)

export default component.exports